import React from "react";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

const ValidationSignCell = (props) => {

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  let icon;
  if (dataValue) {
    icon = <CheckCircleOutlineIcon className="cell-icon cell-icon-successful"/>
  } else {
    icon = <CloseIcon className="cell-icon cell-icon-failed" />
  }

  return (
    <td>
      {icon}
    </td>
  );
};

export default ValidationSignCell;
